import React from "react"
import { getCookieConsentValue } from "react-cookie-consent"

//components
import Navigation from "./navigation/navigation.component"
import PageChanger from "./page-changer/page-changer.component"
import Footer from "./footer/footer.component"
import Control from "./control/control.component"

//slug
import slug from "../components/slug"

const Layout = ({ location, children }) => {
  return (
    <>
      <Navigation location={location} />
      {location &&
        (location.pathname === slug[0] ||
          location.pathname === slug[1] ||
          location.pathname === slug[2]) && <PageChanger location={location} />}
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          cookie:
            typeof window !== "undefined" &&
            getCookieConsentValue("gaRecaptcha"),
        })
      )}
      {typeof window !== "undefined" && <Control />}
      <Footer />
    </>
  )
}

export default Layout
